import {
    AddIcon,
    CompletePersonChip,
    IconChipDepartment,
    IconChipMultiplePerson
} from "../../../components/buttons/IconButtons";
import HeadTittle from "../../../components/HeadTittle";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import { ACTION_MODEL } from "../../../Helpers/ActionModel";
import { permissionObj } from "../../../Helpers/permission";
import routes from "../../../Routes/routes";
import FoodieMainOrdersApp from "../../Dashboard/DiningOrders/Functionality/FoodieMainOrdersApp";
import ExtraMeal from "../Dining/ExtraMeal/ExtraMeal";
import SelectCoffeeShop from "./ContentSteps/DinningOrder/SelectCoffeeShop";
import { TAB_PERMISSION_FOODIE_ORDERS, TABS_FOODIE_ORDERS } from "./Model/Models";
import MyOrdersTable from "./ContentSteps/MyOrders/MyOrdersTable";
import ButtonDropdown from "../../../components/buttons/ButtonDropdown";
import React from "react";
import {EXTRA_MEAL_TYPE_MODEL} from "../Dining/ExtraMeal/Model/Models";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";

/**
 *
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const FoodieMainOrders = () => {

    const {
        t,
        DEV,
        permission,
        navigate,
        activeStep,
        setActiveStep,
        steps,
        bodyForExport,
        setBodyForExport,
        subView,
        setSubView,
        handleStepChange,
        handleCreateDelete,
        permissionButtons,
        showRequestModal,
        setShowRequestModal,
        extraMealType,
        setExtraMealType,
        search,
        criteria,
        option,
        setOption,
        moduleId,
        setModuleId,
        searchElement,
        setSearch,
        simpleSearch,
        setSimpleSearch
    } = FoodieMainOrdersApp();

    //If don't have permissions redirec to to Forbidden page
    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_FOODIE_MENU_SELECTION_VIEW) &&
        !permission?.includes(permissionObj?.WEB_FOODIE_EXTRA_REQUEST_VIEW)
    ) navigate(routes.forbidden);



    return (<>
        <HeadTittle name={'foodie_dining'} >
            {permissionButtons(TAB_PERMISSION_FOODIE_ORDERS(subView).EXPORT) &&
                (search ? (
                    <ExportDataBtn
                        moduleId={moduleId}
                        body={criteria}
                        search={search}
                        option={option}
                    />
                ) : (
                    <ExportDataBtn
                        moduleId={moduleId}
                        searchElement={searchElement}
                        search={search}
                        option={option}
                        body={bodyForExport}
                    />
                ))
            }

            {permissionButtons(TAB_PERMISSION_FOODIE_ORDERS(subView).CREATE) &&
                <ButtonDropdown
                    id={'btn_fmo_create'}
                    classes={'btn-icon-add'}
                    trans={'create'}
                    spliName={false}
                    icon={AddIcon}
                    options={[
                        {
                            id: 'mim_fmo_personal',
                            option: t('personal'),
                            action: () => handleCreateDelete(ACTION_MODEL.CREATE, EXTRA_MEAL_TYPE_MODEL.PERSONAL),
                            icon: <CompletePersonChip className={"w-24px h-24px"}/>
                        },
                        {
                            id: 'mim_fmo_for_employees',
                            option: t('for_employees'),
                            action: () => handleCreateDelete(ACTION_MODEL.CREATE, EXTRA_MEAL_TYPE_MODEL.FOR_EMPLOYEES),
                            icon: <IconChipMultiplePerson className={"w-24px h-24px"}/>
                        },
                        {
                            id: 'mim_fmo_for_departments',
                            option: t('for_departments'),
                            action: () => handleCreateDelete(ACTION_MODEL.CREATE, EXTRA_MEAL_TYPE_MODEL.FOR_DEPARTMENTS),
                            icon: <IconChipDepartment className={"w-24px h-24px"}/>
                        },
                    ]}
                />
            }
        </HeadTittle>
        <StepperTabs
            id={null}
            onlyTab={true}
            disabled={false}
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab index={TABS_FOODIE_ORDERS.ORDER.INDEX} activeStep={activeStep}>
                {activeStep === TABS_FOODIE_ORDERS.ORDER.INDEX && <SelectCoffeeShop />}
            </StepTab>
            <StepTab index={TABS_FOODIE_ORDERS.MY_ORDERS.INDEX} activeStep={activeStep}>
                {activeStep === TABS_FOODIE_ORDERS.MY_ORDERS.INDEX && <MyOrdersTable />}
            </StepTab>
            <StepTab normalHeight={true} index={TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX} activeStep={activeStep}>
                {activeStep === TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX && (
                    <ExtraMeal
                        subView={subView}
                        setSubView={setSubView}
                        setBodyForExport={setBodyForExport}
                        showRequestModal={showRequestModal}
                        setShowRequestModal={setShowRequestModal}
                        extraMealType={extraMealType}
                        setExtraMealType={setExtraMealType}
                        option={option}
                        setOption={setOption}
                        setModuleId={setModuleId}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                    />
                )}
            </StepTab>
        </StepperTabs>
    </>)
}

export default FoodieMainOrders;
